import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HiThumbUp, HiThumbDown } from 'react-icons/hi';
import DialogComponent from '../dialog/dialog.component';
import Loading from '../loading/loading.component';
import { CommentVoter, getCommentVoters } from '../../api/posts/comment-voters.api';

interface Props {
  commentId: string;
  /** 1 = like, -1 = dislike */
  type: number;
  onClose: () => void;
}

const CommentVotersDialog: React.FC<Props> = ({ commentId, type, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [voters, setVoters] = useState<CommentVoter[]>([]);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getCommentVoters(commentId, type)
      .then((list) => alive && setVoters(list))
      .catch(() => alive && setVoters([]))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [commentId, type]);

  return (
    <DialogComponent
      visible
      onClose={onClose}
      title={type === -1 ? 'Người không thích' : 'Người thích'}
      placement="CENTER"
    >
      <div className="w-full max-w-[380px] p-4">
        <div className="mb-2 flex items-center gap-1.5 text-sm font-medium text-slate-500 dark:text-slate-400">
          {type === -1 ? (
            <HiThumbDown className="text-red-500" size={16} />
          ) : (
            <HiThumbUp className="text-blue-500" size={16} />
          )}
          {voters.length} người
        </div>

        {loading ? (
          <Loading classname="mx-auto my-6" />
        ) : voters.length === 0 ? (
          <p className="py-6 text-center text-sm text-slate-500 dark:text-slate-400">
            Chưa có ai.
          </p>
        ) : (
          <ul className="max-h-[360px] space-y-1 overflow-y-auto">
            {voters.map((v) => (
              <li key={v.userId}>
                <Link
                  to={`/user/${v.username || v.userId}`}
                  onClick={onClose}
                  className="flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-slate-50 dark:hover:bg-slate-800"
                >
                  <img
                    src={v.avatar || '/default-avatar.png'}
                    alt=""
                    className="h-9 w-9 shrink-0 rounded-full bg-slate-200 object-cover dark:bg-slate-700"
                  />
                  <span className="truncate text-sm font-medium text-slate-800 dark:text-slate-100">
                    {v.fullName || v.username || 'Người dùng'}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </DialogComponent>
  );
};

export default CommentVotersDialog;
